import api from "./axios";
import SsoRequest from "../requests/SsoRequest";
import SsoResponse from "../responses/SsoResponse";

export class SsoService{
    async getSsoLandingPageUrl(applicationName: string, clubId: number, referralUrl?: string) {
        const response = await api.get(`/sso/redirect/${applicationName}/${clubId}/${referralUrl ?? ""}`);
        return response.data as string;
    }

    async getSsoLogoutUrl(applicationName: string, clubId: number) {
        const response = await api.get(`/sso/logout/${applicationName}/${clubId}`);
        return response.data as string;
    }

    async handleSsoRedirect(ssoRequest: SsoRequest) {
        const response = await api.post(`authentication/sso`, ssoRequest);
        return response.data as SsoResponse;
    }
}

export default new SsoService();